// The backend's base URL, set per environment at build time.
const baseUrl: any = process.env.REACT_APP_BASE_URL;

export default baseUrl;
